import {Injectable} from "@angular/core";
import {APIProxy, HttpObservable} from "../../http/services";
import {IClientContext} from "../../../app.services/user.context/interfaces/Iclient.context";
import {IVersionDetails} from "../interfaces/version.details";

@Injectable()
export class VersionDetailsProxy {

	private readonly RIS_WEB_CLIENT_ID = 1;

	constructor(private apiHttp:APIProxy) {
	}

	public getVersionDetails():HttpObservable<IVersionDetails> {
		return this.apiHttp.getAnon("VersionDetails", "GetVersionDetails", {pName: 'clientId', pVal: this.RIS_WEB_CLIENT_ID});
	}
}
